import type {AnalyticsInstance} from 'analytics';

import {createEzcaterAnalytics} from '../core/ezcaterAnalytics';

declare global {
  interface Window {
    ezcaterAnalytics?: AnalyticsInstance;
  }
}

const script = document.getElementById('ezcater-analytics-sdk-script');

if (script) {
  const writeKey = script.getAttribute('data-rudderstack-write-key') || '';
  const dataPlaneUrl = script.getAttribute('data-rudderstack-data-plane-url') || '';

  const analytics = createEzcaterAnalytics({
    rudderstack: {writeKey, dataPlaneUrl},
  });

  window.ezcaterAnalytics = analytics;
}
